var $879d66a4ec6ff3f5$exports = {};
$879d66a4ec6ff3f5$exports = {
    "Clear search": `\u{5E0}\u{5E7}\u{5D4} \u{5D7}\u{5D9}\u{5E4}\u{5D5}\u{5E9}`
};


export {$879d66a4ec6ff3f5$exports as default};
//# sourceMappingURL=he-IL.mjs.map
